import { IStructureResponse } from '../Models/Structure/IStructure';
import { ISectorResponse } from '../Models/Sector/ISector';

const headers = new Headers();
headers.append('Accept-Language', document.querySelector('html')!.lang);
headers.append('Content-Type', 'application/json');

export const PrimeService = {
    async GetAllStructures(): Promise<IStructureResponse> {
        const response = await fetch('/api/FondsRebond/GetAllStructures', {
            method: 'GET',
            headers,
        });
        return await response.json();
    },

    async GetAllSectors(): Promise<ISectorResponse> {
        const response = await fetch('/api/FondsRebond/GetAllSectors', {
            method: 'GET',
            headers,
        });
        return await response.json();
    },
};
